import api from '../services/ApiService';

export const DB_DESCRIBE_ITEM = 'DB_DESCRIBE_ITEM';
export const DB_CREATE_ITEM = 'DB_CREATE_ITEM';
export const DB_GET_DATA = 'DB_GET_DATA';
export const DB_GET_ITEM = 'DB_GET_ITEM';
export const DB_REMOVE_ITEM = 'DB_REMOVE_ITEM';
export const DB_UPDATE_ITEM = 'DB_UPDATE_ITEM';
export const DB_UNMOUNT_ITEM = 'DB_UNMOUNT_ITEM';

export function createItem(pageName, data) {
  return {
    type: DB_CREATE_ITEM,
    payload: api.post(`/db/${pageName}`, data),
  };
}

export function describeItem(pageName) {
  return {
    type: DB_DESCRIBE_ITEM,
    payload: api.get(`/db/${pageName}/describe`),
    meta: {
      pageName,
    },
  };
}

export function getData(pageName, { filter } = {}) {
  return {
    type: DB_GET_DATA,
    payload: api.get(`/db/${pageName}`, { params: { filter } }),
    meta: {
      pageName,
    },
  };
}

export function getItem(pageName, id) {
  return {
    type: DB_GET_ITEM,
    payload: api.get(`/db/${pageName}/${id}`),
  };
}

export function removeItem(pageName, id) {
  return {
    type: DB_REMOVE_ITEM,
    payload: api.delete(`/db/${pageName}/${id}`),
    meta: {
      pageName,
    },
  };
}

export function updateItem(pageName, id, data) {
  return {
    type: DB_UPDATE_ITEM,
    payload: api.put(`/db/${pageName}/${id}`, data),
  };
}

export function unmountItem() {
  return {
    type: DB_UNMOUNT_ITEM,
  };
}
